// 首页统计数据接口
// 系统管理接口
import admApi from './administrators';
// 权限管理接口
import authorApi from './author';
import homeApi from './home';
import aiManage from './aiManage';
import systemManage from './systemManage';
// 登陆api接口
import loginApi from './login';
import aiFriendManageApi from './aiFriendManage';

const Api = Object.assign({
  ...loginApi,
  ...admApi,
  ...authorApi,
  ...homeApi,
  ...aiManage,
  ...systemManage,
  ...aiFriendManageApi
});
export default Api;